module.exports = __webpack_public_path__ + "static/media/cost_efficiency.18e8140b.svg";